/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as LangIndexRouteImport } from './routes/$lang/index'
import { Route as LangLayoutRouteImport } from './routes/$lang/_layout'
import { Route as LangLayoutAuthLoginRouteImport } from './routes/$lang/_layout/auth/login'
import { Route as LangLayoutAuthRedirectRouteImport } from './routes/$lang/_layout/auth/redirect'
import { Route as LangLayoutAuthResetPasswordRouteImport } from './routes/$lang/_layout/auth/reset-password'
import { Route as LangLayoutOrgsOrgLayoutRouteImport } from './routes/$lang/_layout/orgs/$org/_layout'
import { Route as LangLayoutOrgsOrgLayoutIndexRouteImport } from './routes/$lang/_layout/orgs/$org/_layout/index'
import { Route as LangLayoutOrgsOrgLayoutAnalyticsRouteImport } from './routes/$lang/_layout/orgs/$org/_layout/analytics'
import { Route as LangLayoutOrgsOrgLayoutDeliverRouteRouteImport } from './routes/$lang/_layout/orgs/$org/_layout/deliver/route'
import { Route as LangLayoutOrgsOrgLayoutInternalRouteRouteImport } from './routes/$lang/_layout/orgs/$org/_layout/internal/route'
import { Route as LangLayoutOrgsOrgLayoutOutboundRouteRouteImport } from './routes/$lang/_layout/orgs/$org/_layout/outbound/route'
import { Route as LangLayoutOrgsOrgLayoutDeliverIndexRouteImport } from './routes/$lang/_layout/orgs/$org/_layout/deliver/index'
import { Route as LangLayoutOrgsOrgLayoutInternalIndexRouteImport } from './routes/$lang/_layout/orgs/$org/_layout/internal/index'
import { Route as LangLayoutOrgsOrgLayoutOutboundIndexRouteImport } from './routes/$lang/_layout/orgs/$org/_layout/outbound/index'
import { Route as LangLayoutOrgsOrgLayoutDeliverManageTenantRouteImport } from './routes/$lang/_layout/orgs/$org/_layout/deliver/manage/$tenant'
import { Route as LangLayoutOrgsOrgLayoutDeliverManageTenantIndexRouteImport } from './routes/$lang/_layout/orgs/$org/_layout/deliver/manage/$tenant/index'
import { Route as LangLayoutOrgsOrgLayoutDeliverManageTenantDriversRouteImport } from './routes/$lang/_layout/orgs/$org/_layout/deliver/manage/$tenant/drivers'
import { Route as LangLayoutOrgsOrgLayoutDeliverManageTenantQuestionsRouteImport } from './routes/$lang/_layout/orgs/$org/_layout/deliver/manage/$tenant/questions'
import { Route as LangLayoutOrgsOrgLayoutDeliverManageTenantSettingsRouteImport } from './routes/$lang/_layout/orgs/$org/_layout/deliver/manage/$tenant/settings'
import { Route as LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutRouteImport } from './routes/$lang/_layout/orgs/$org/_layout/internal/whs/$location/_layout'
import { Route as LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutRouteImport } from './routes/$lang/_layout/orgs/$org/_layout/outbound/whs/$location/_layout'
import { Route as LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutIndexRouteImport } from './routes/$lang/_layout/orgs/$org/_layout/internal/whs/$location/_layout/index'
import { Route as LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutFtpRouteImport } from './routes/$lang/_layout/orgs/$org/_layout/internal/whs/$location/_layout/ftp'
import { Route as LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutFtpConfigRouteImport } from './routes/$lang/_layout/orgs/$org/_layout/internal/whs/$location/_layout/ftp-config'
import { Route as LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutHomeRouteImport } from './routes/$lang/_layout/orgs/$org/_layout/internal/whs/$location/_layout/home'
import { Route as LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutIndexRouteImport } from './routes/$lang/_layout/orgs/$org/_layout/outbound/whs/$location/_layout/index'
import { Route as LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutCustomersRouteImport } from './routes/$lang/_layout/orgs/$org/_layout/outbound/whs/$location/_layout/customers'
import { Route as LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutItemsRouteImport } from './routes/$lang/_layout/orgs/$org/_layout/outbound/whs/$location/_layout/items'
import { Route as LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutLocationsRouteImport } from './routes/$lang/_layout/orgs/$org/_layout/outbound/whs/$location/_layout/locations'
import { Route as LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutSelectorsRouteImport } from './routes/$lang/_layout/orgs/$org/_layout/outbound/whs/$location/_layout/selectors'
import { Route as LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutUserGroupsRouteImport } from './routes/$lang/_layout/orgs/$org/_layout/outbound/whs/$location/_layout/user-groups'
import { Route as LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutZonesRouteImport } from './routes/$lang/_layout/orgs/$org/_layout/outbound/whs/$location/_layout/zones'
import { Route as LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutSelectorSessionsIndexRouteImport } from './routes/$lang/_layout/orgs/$org/_layout/internal/whs/$location/_layout/selector-sessions/index'
import { Route as LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutTaskPlanErrorsIndexRouteImport } from './routes/$lang/_layout/orgs/$org/_layout/internal/whs/$location/_layout/task-plan-errors/index'
import { Route as LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutTaskPlansIndexRouteImport } from './routes/$lang/_layout/orgs/$org/_layout/internal/whs/$location/_layout/task-plans/index'
import { Route as LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutAuditLogIndexRouteImport } from './routes/$lang/_layout/orgs/$org/_layout/outbound/whs/$location/_layout/audit-log/index'
import { Route as LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutDashboardIndexRouteImport } from './routes/$lang/_layout/orgs/$org/_layout/outbound/whs/$location/_layout/dashboard/index'
import { Route as LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutSystemControlsIndexRouteImport } from './routes/$lang/_layout/orgs/$org/_layout/outbound/whs/$location/_layout/system-controls/index'
import { Route as LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutTasksLayoutRouteImport } from './routes/$lang/_layout/orgs/$org/_layout/outbound/whs/$location/_layout/tasks/_layout'
import { Route as LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutSelectorTasksSelectorIdIndexRouteImport } from './routes/$lang/_layout/orgs/$org/_layout/internal/whs/$location/_layout/selector-tasks/$selectorId/index'
import { Route as LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutTaskPlansTaskPlanIndexRouteImport } from './routes/$lang/_layout/orgs/$org/_layout/internal/whs/$location/_layout/task-plans/$task-plan/index'
import { Route as LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutTaskPlansLoadPlansIndexRouteImport } from './routes/$lang/_layout/orgs/$org/_layout/internal/whs/$location/_layout/task-plans/load-plans/index'
import { Route as LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutWebhooksEndpointsIndexRouteImport } from './routes/$lang/_layout/orgs/$org/_layout/internal/whs/$location/_layout/webhooks/endpoints/index'
import { Route as LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutWebhooksEndpointsNewRouteImport } from './routes/$lang/_layout/orgs/$org/_layout/internal/whs/$location/_layout/webhooks/endpoints/new'
import { Route as LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutTasksLayoutIndexRouteImport } from './routes/$lang/_layout/orgs/$org/_layout/outbound/whs/$location/_layout/tasks/_layout/index'
import { Route as LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutTaskPlansTaskPlanTaskIndexRouteImport } from './routes/$lang/_layout/orgs/$org/_layout/internal/whs/$location/_layout/task-plans/$task-plan/$task/index'
import { Route as LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutTaskPlansTaskPlanSimulateIndexRouteImport } from './routes/$lang/_layout/orgs/$org/_layout/internal/whs/$location/_layout/task-plans/$task-plan/simulate/index'
import { Route as LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutWebhooksEndpointsEndpointDeliveriesRouteImport } from './routes/$lang/_layout/orgs/$org/_layout/internal/whs/$location/_layout/webhooks/endpoints/$endpoint/deliveries'
import { Route as LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutTasksLayoutAllIndexRouteImport } from './routes/$lang/_layout/orgs/$org/_layout/outbound/whs/$location/_layout/tasks/_layout/all/index'
import { Route as LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutTasksLayoutPlansIndexRouteImport } from './routes/$lang/_layout/orgs/$org/_layout/outbound/whs/$location/_layout/tasks/_layout/plans/index'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const LangIndexRoute = LangIndexRouteImport.update({
  id: '/$lang/',
  path: '/$lang/',
  getParentRoute: () => rootRouteImport,
} as any)
const LangLayoutRoute = LangLayoutRouteImport.update({
  id: '/$lang/_layout',
  path: '/$lang',
  getParentRoute: () => rootRouteImport,
} as any)
const LangLayoutAuthLoginRoute = LangLayoutAuthLoginRouteImport.update({
  id: '/auth/login',
  path: '/auth/login',
  getParentRoute: () => LangLayoutRoute,
} as any)
const LangLayoutAuthRedirectRoute = LangLayoutAuthRedirectRouteImport.update({
  id: '/auth/redirect',
  path: '/auth/redirect',
  getParentRoute: () => LangLayoutRoute,
} as any)
const LangLayoutAuthResetPasswordRoute =
  LangLayoutAuthResetPasswordRouteImport.update({
    id: '/auth/reset-password',
    path: '/auth/reset-password',
    getParentRoute: () => LangLayoutRoute,
  } as any)
const LangLayoutOrgsOrgLayoutRoute = LangLayoutOrgsOrgLayoutRouteImport.update({
  id: '/orgs/$org/_layout',
  path: '/orgs/$org',
  getParentRoute: () => LangLayoutRoute,
} as any)
const LangLayoutOrgsOrgLayoutIndexRoute =
  LangLayoutOrgsOrgLayoutIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => LangLayoutOrgsOrgLayoutRoute,
  } as any)
const LangLayoutOrgsOrgLayoutAnalyticsRoute =
  LangLayoutOrgsOrgLayoutAnalyticsRouteImport.update({
    id: '/analytics',
    path: '/analytics',
    getParentRoute: () => LangLayoutOrgsOrgLayoutRoute,
  } as any)
const LangLayoutOrgsOrgLayoutDeliverRouteRoute =
  LangLayoutOrgsOrgLayoutDeliverRouteRouteImport.update({
    id: '/deliver',
    path: '/deliver',
    getParentRoute: () => LangLayoutOrgsOrgLayoutRoute,
  } as any)
const LangLayoutOrgsOrgLayoutInternalRouteRoute =
  LangLayoutOrgsOrgLayoutInternalRouteRouteImport.update({
    id: '/internal',
    path: '/internal',
    getParentRoute: () => LangLayoutOrgsOrgLayoutRoute,
  } as any)
const LangLayoutOrgsOrgLayoutOutboundRouteRoute =
  LangLayoutOrgsOrgLayoutOutboundRouteRouteImport.update({
    id: '/outbound',
    path: '/outbound',
    getParentRoute: () => LangLayoutOrgsOrgLayoutRoute,
  } as any)
const LangLayoutOrgsOrgLayoutDeliverIndexRoute =
  LangLayoutOrgsOrgLayoutDeliverIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => LangLayoutOrgsOrgLayoutDeliverRouteRoute,
  } as any)
const LangLayoutOrgsOrgLayoutInternalIndexRoute =
  LangLayoutOrgsOrgLayoutInternalIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => LangLayoutOrgsOrgLayoutInternalRouteRoute,
  } as any)
const LangLayoutOrgsOrgLayoutOutboundIndexRoute =
  LangLayoutOrgsOrgLayoutOutboundIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => LangLayoutOrgsOrgLayoutOutboundRouteRoute,
  } as any)
const LangLayoutOrgsOrgLayoutDeliverManageTenantRoute =
  LangLayoutOrgsOrgLayoutDeliverManageTenantRouteImport.update({
    id: '/manage/$tenant',
    path: '/manage/$tenant',
    getParentRoute: () => LangLayoutOrgsOrgLayoutDeliverRouteRoute,
  } as any)
const LangLayoutOrgsOrgLayoutDeliverManageTenantIndexRoute =
  LangLayoutOrgsOrgLayoutDeliverManageTenantIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => LangLayoutOrgsOrgLayoutDeliverManageTenantRoute,
  } as any)
const LangLayoutOrgsOrgLayoutDeliverManageTenantDriversRoute =
  LangLayoutOrgsOrgLayoutDeliverManageTenantDriversRouteImport.update({
    id: '/drivers',
    path: '/drivers',
    getParentRoute: () => LangLayoutOrgsOrgLayoutDeliverManageTenantRoute,
  } as any)
const LangLayoutOrgsOrgLayoutDeliverManageTenantQuestionsRoute =
  LangLayoutOrgsOrgLayoutDeliverManageTenantQuestionsRouteImport.update({
    id: '/questions',
    path: '/questions',
    getParentRoute: () => LangLayoutOrgsOrgLayoutDeliverManageTenantRoute,
  } as any)
const LangLayoutOrgsOrgLayoutDeliverManageTenantSettingsRoute =
  LangLayoutOrgsOrgLayoutDeliverManageTenantSettingsRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => LangLayoutOrgsOrgLayoutDeliverManageTenantRoute,
  } as any)
const LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutRoute =
  LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutRouteImport.update({
    id: '/whs/$location/_layout',
    path: '/whs/$location',
    getParentRoute: () => LangLayoutOrgsOrgLayoutInternalRouteRoute,
  } as any)
const LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutRoute =
  LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutRouteImport.update({
    id: '/whs/$location/_layout',
    path: '/whs/$location',
    getParentRoute: () => LangLayoutOrgsOrgLayoutOutboundRouteRoute,
  } as any)
const LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutIndexRoute =
  LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutRoute,
  } as any)
const LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutFtpRoute =
  LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutFtpRouteImport.update({
    id: '/ftp',
    path: '/ftp',
    getParentRoute: () => LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutRoute,
  } as any)
const LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutFtpConfigRoute =
  LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutFtpConfigRouteImport.update({
    id: '/ftp-config',
    path: '/ftp-config',
    getParentRoute: () => LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutRoute,
  } as any)
const LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutHomeRoute =
  LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutHomeRouteImport.update({
    id: '/home',
    path: '/home',
    getParentRoute: () => LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutRoute,
  } as any)
const LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutIndexRoute =
  LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutRoute,
  } as any)
const LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutCustomersRoute =
  LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutCustomersRouteImport.update({
    id: '/customers',
    path: '/customers',
    getParentRoute: () => LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutRoute,
  } as any)
const LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutItemsRoute =
  LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutItemsRouteImport.update({
    id: '/items',
    path: '/items',
    getParentRoute: () => LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutRoute,
  } as any)
const LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutLocationsRoute =
  LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutLocationsRouteImport.update({
    id: '/locations',
    path: '/locations',
    getParentRoute: () => LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutRoute,
  } as any)
const LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutSelectorsRoute =
  LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutSelectorsRouteImport.update({
    id: '/selectors',
    path: '/selectors',
    getParentRoute: () => LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutRoute,
  } as any)
const LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutUserGroupsRoute =
  LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutUserGroupsRouteImport.update({
    id: '/user-groups',
    path: '/user-groups',
    getParentRoute: () => LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutRoute,
  } as any)
const LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutZonesRoute =
  LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutZonesRouteImport.update({
    id: '/zones',
    path: '/zones',
    getParentRoute: () => LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutRoute,
  } as any)
const LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutSelectorSessionsIndexRoute =
  LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutSelectorSessionsIndexRouteImport.update(
    {
      id: '/selector-sessions/',
      path: '/selector-sessions/',
      getParentRoute: () =>
        LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutRoute,
    } as any,
  )
const LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutTaskPlanErrorsIndexRoute =
  LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutTaskPlanErrorsIndexRouteImport.update(
    {
      id: '/task-plan-errors/',
      path: '/task-plan-errors/',
      getParentRoute: () =>
        LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutRoute,
    } as any,
  )
const LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutTaskPlansIndexRoute =
  LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutTaskPlansIndexRouteImport.update(
    {
      id: '/task-plans/',
      path: '/task-plans/',
      getParentRoute: () =>
        LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutRoute,
    } as any,
  )
const LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutAuditLogIndexRoute =
  LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutAuditLogIndexRouteImport.update(
    {
      id: '/audit-log/',
      path: '/audit-log/',
      getParentRoute: () =>
        LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutRoute,
    } as any,
  )
const LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutDashboardIndexRoute =
  LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutDashboardIndexRouteImport.update(
    {
      id: '/dashboard/',
      path: '/dashboard/',
      getParentRoute: () =>
        LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutRoute,
    } as any,
  )
const LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutSystemControlsIndexRoute =
  LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutSystemControlsIndexRouteImport.update(
    {
      id: '/system-controls/',
      path: '/system-controls/',
      getParentRoute: () =>
        LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutRoute,
    } as any,
  )
const LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutTasksLayoutRoute =
  LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutTasksLayoutRouteImport.update(
    {
      id: '/tasks/_layout',
      path: '/tasks',
      getParentRoute: () =>
        LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutRoute,
    } as any,
  )
const LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutSelectorTasksSelectorIdIndexRoute =
  LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutSelectorTasksSelectorIdIndexRouteImport.update(
    {
      id: '/selector-tasks/$selectorId/',
      path: '/selector-tasks/$selectorId/',
      getParentRoute: () =>
        LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutRoute,
    } as any,
  )
const LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutTaskPlansTaskPlanIndexRoute =
  LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutTaskPlansTaskPlanIndexRouteImport.update(
    {
      id: '/task-plans/$task-plan/',
      path: '/task-plans/$task-plan/',
      getParentRoute: () =>
        LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutRoute,
    } as any,
  )
const LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutTaskPlansLoadPlansIndexRoute =
  LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutTaskPlansLoadPlansIndexRouteImport.update(
    {
      id: '/task-plans/load-plans/',
      path: '/task-plans/load-plans/',
      getParentRoute: () =>
        LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutRoute,
    } as any,
  )
const LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutWebhooksEndpointsIndexRoute =
  LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutWebhooksEndpointsIndexRouteImport.update(
    {
      id: '/webhooks/endpoints/',
      path: '/webhooks/endpoints/',
      getParentRoute: () =>
        LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutRoute,
    } as any,
  )
const LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutWebhooksEndpointsNewRoute =
  LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutWebhooksEndpointsNewRouteImport.update(
    {
      id: '/webhooks/endpoints/new',
      path: '/webhooks/endpoints/new',
      getParentRoute: () =>
        LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutRoute,
    } as any,
  )
const LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutTasksLayoutIndexRoute =
  LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutTasksLayoutIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutTasksLayoutRoute,
    } as any,
  )
const LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutTaskPlansTaskPlanTaskIndexRoute =
  LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutTaskPlansTaskPlanTaskIndexRouteImport.update(
    {
      id: '/task-plans/$task-plan/$task/',
      path: '/task-plans/$task-plan/$task/',
      getParentRoute: () =>
        LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutRoute,
    } as any,
  )
const LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutTaskPlansTaskPlanSimulateIndexRoute =
  LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutTaskPlansTaskPlanSimulateIndexRouteImport.update(
    {
      id: '/task-plans/$task-plan/simulate/',
      path: '/task-plans/$task-plan/simulate/',
      getParentRoute: () =>
        LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutRoute,
    } as any,
  )
const LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutWebhooksEndpointsEndpointDeliveriesRoute =
  LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutWebhooksEndpointsEndpointDeliveriesRouteImport.update(
    {
      id: '/webhooks/endpoints/$endpoint/deliveries',
      path: '/webhooks/endpoints/$endpoint/deliveries',
      getParentRoute: () =>
        LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutRoute,
    } as any,
  )
const LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutTasksLayoutAllIndexRoute =
  LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutTasksLayoutAllIndexRouteImport.update(
    {
      id: '/all/',
      path: '/all/',
      getParentRoute: () =>
        LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutTasksLayoutRoute,
    } as any,
  )
const LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutTasksLayoutPlansIndexRoute =
  LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutTasksLayoutPlansIndexRouteImport.update(
    {
      id: '/plans/',
      path: '/plans/',
      getParentRoute: () =>
        LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutTasksLayoutRoute,
    } as any,
  )

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/$lang': typeof LangLayoutRouteWithChildren
  '/$lang/': typeof LangIndexRoute
  '/$lang/auth/login': typeof LangLayoutAuthLoginRoute
  '/$lang/auth/redirect': typeof LangLayoutAuthRedirectRoute
  '/$lang/auth/reset-password': typeof LangLayoutAuthResetPasswordRoute
  '/$lang/orgs/$org': typeof LangLayoutOrgsOrgLayoutRouteWithChildren
  '/$lang/orgs/$org/deliver': typeof LangLayoutOrgsOrgLayoutDeliverRouteRouteWithChildren
  '/$lang/orgs/$org/internal': typeof LangLayoutOrgsOrgLayoutInternalRouteRouteWithChildren
  '/$lang/orgs/$org/outbound': typeof LangLayoutOrgsOrgLayoutOutboundRouteRouteWithChildren
  '/$lang/orgs/$org/analytics': typeof LangLayoutOrgsOrgLayoutAnalyticsRoute
  '/$lang/orgs/$org/': typeof LangLayoutOrgsOrgLayoutIndexRoute
  '/$lang/orgs/$org/deliver/': typeof LangLayoutOrgsOrgLayoutDeliverIndexRoute
  '/$lang/orgs/$org/internal/': typeof LangLayoutOrgsOrgLayoutInternalIndexRoute
  '/$lang/orgs/$org/outbound/': typeof LangLayoutOrgsOrgLayoutOutboundIndexRoute
  '/$lang/orgs/$org/deliver/manage/$tenant': typeof LangLayoutOrgsOrgLayoutDeliverManageTenantRouteWithChildren
  '/$lang/orgs/$org/deliver/manage/$tenant/drivers': typeof LangLayoutOrgsOrgLayoutDeliverManageTenantDriversRoute
  '/$lang/orgs/$org/deliver/manage/$tenant/questions': typeof LangLayoutOrgsOrgLayoutDeliverManageTenantQuestionsRoute
  '/$lang/orgs/$org/deliver/manage/$tenant/settings': typeof LangLayoutOrgsOrgLayoutDeliverManageTenantSettingsRoute
  '/$lang/orgs/$org/internal/whs/$location': typeof LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutRouteWithChildren
  '/$lang/orgs/$org/outbound/whs/$location': typeof LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutRouteWithChildren
  '/$lang/orgs/$org/deliver/manage/$tenant/': typeof LangLayoutOrgsOrgLayoutDeliverManageTenantIndexRoute
  '/$lang/orgs/$org/internal/whs/$location/ftp': typeof LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutFtpRoute
  '/$lang/orgs/$org/internal/whs/$location/ftp-config': typeof LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutFtpConfigRoute
  '/$lang/orgs/$org/internal/whs/$location/home': typeof LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutHomeRoute
  '/$lang/orgs/$org/outbound/whs/$location/customers': typeof LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutCustomersRoute
  '/$lang/orgs/$org/outbound/whs/$location/items': typeof LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutItemsRoute
  '/$lang/orgs/$org/outbound/whs/$location/locations': typeof LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutLocationsRoute
  '/$lang/orgs/$org/outbound/whs/$location/selectors': typeof LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutSelectorsRoute
  '/$lang/orgs/$org/outbound/whs/$location/user-groups': typeof LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutUserGroupsRoute
  '/$lang/orgs/$org/outbound/whs/$location/zones': typeof LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutZonesRoute
  '/$lang/orgs/$org/internal/whs/$location/': typeof LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutIndexRoute
  '/$lang/orgs/$org/outbound/whs/$location/': typeof LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutIndexRoute
  '/$lang/orgs/$org/outbound/whs/$location/tasks': typeof LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutTasksLayoutRouteWithChildren
  '/$lang/orgs/$org/internal/whs/$location/selector-sessions/': typeof LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutSelectorSessionsIndexRoute
  '/$lang/orgs/$org/internal/whs/$location/task-plan-errors/': typeof LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutTaskPlanErrorsIndexRoute
  '/$lang/orgs/$org/internal/whs/$location/task-plans/': typeof LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutTaskPlansIndexRoute
  '/$lang/orgs/$org/outbound/whs/$location/audit-log/': typeof LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutAuditLogIndexRoute
  '/$lang/orgs/$org/outbound/whs/$location/dashboard/': typeof LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutDashboardIndexRoute
  '/$lang/orgs/$org/outbound/whs/$location/system-controls/': typeof LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutSystemControlsIndexRoute
  '/$lang/orgs/$org/internal/whs/$location/webhooks/endpoints/new': typeof LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutWebhooksEndpointsNewRoute
  '/$lang/orgs/$org/internal/whs/$location/selector-tasks/$selectorId/': typeof LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutSelectorTasksSelectorIdIndexRoute
  '/$lang/orgs/$org/internal/whs/$location/task-plans/$task-plan/': typeof LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutTaskPlansTaskPlanIndexRoute
  '/$lang/orgs/$org/internal/whs/$location/task-plans/load-plans/': typeof LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutTaskPlansLoadPlansIndexRoute
  '/$lang/orgs/$org/internal/whs/$location/webhooks/endpoints/': typeof LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutWebhooksEndpointsIndexRoute
  '/$lang/orgs/$org/outbound/whs/$location/tasks/': typeof LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutTasksLayoutIndexRoute
  '/$lang/orgs/$org/internal/whs/$location/webhooks/endpoints/$endpoint/deliveries': typeof LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutWebhooksEndpointsEndpointDeliveriesRoute
  '/$lang/orgs/$org/internal/whs/$location/task-plans/$task-plan/$task/': typeof LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutTaskPlansTaskPlanTaskIndexRoute
  '/$lang/orgs/$org/internal/whs/$location/task-plans/$task-plan/simulate/': typeof LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutTaskPlansTaskPlanSimulateIndexRoute
  '/$lang/orgs/$org/outbound/whs/$location/tasks/all/': typeof LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutTasksLayoutAllIndexRoute
  '/$lang/orgs/$org/outbound/whs/$location/tasks/plans/': typeof LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutTasksLayoutPlansIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/$lang': typeof LangIndexRoute
  '/$lang/auth/login': typeof LangLayoutAuthLoginRoute
  '/$lang/auth/redirect': typeof LangLayoutAuthRedirectRoute
  '/$lang/auth/reset-password': typeof LangLayoutAuthResetPasswordRoute
  '/$lang/orgs/$org/analytics': typeof LangLayoutOrgsOrgLayoutAnalyticsRoute
  '/$lang/orgs/$org': typeof LangLayoutOrgsOrgLayoutIndexRoute
  '/$lang/orgs/$org/deliver': typeof LangLayoutOrgsOrgLayoutDeliverIndexRoute
  '/$lang/orgs/$org/internal': typeof LangLayoutOrgsOrgLayoutInternalIndexRoute
  '/$lang/orgs/$org/outbound': typeof LangLayoutOrgsOrgLayoutOutboundIndexRoute
  '/$lang/orgs/$org/deliver/manage/$tenant/drivers': typeof LangLayoutOrgsOrgLayoutDeliverManageTenantDriversRoute
  '/$lang/orgs/$org/deliver/manage/$tenant/questions': typeof LangLayoutOrgsOrgLayoutDeliverManageTenantQuestionsRoute
  '/$lang/orgs/$org/deliver/manage/$tenant/settings': typeof LangLayoutOrgsOrgLayoutDeliverManageTenantSettingsRoute
  '/$lang/orgs/$org/deliver/manage/$tenant': typeof LangLayoutOrgsOrgLayoutDeliverManageTenantIndexRoute
  '/$lang/orgs/$org/internal/whs/$location/ftp': typeof LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutFtpRoute
  '/$lang/orgs/$org/internal/whs/$location/ftp-config': typeof LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutFtpConfigRoute
  '/$lang/orgs/$org/internal/whs/$location/home': typeof LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutHomeRoute
  '/$lang/orgs/$org/outbound/whs/$location/customers': typeof LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutCustomersRoute
  '/$lang/orgs/$org/outbound/whs/$location/items': typeof LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutItemsRoute
  '/$lang/orgs/$org/outbound/whs/$location/locations': typeof LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutLocationsRoute
  '/$lang/orgs/$org/outbound/whs/$location/selectors': typeof LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutSelectorsRoute
  '/$lang/orgs/$org/outbound/whs/$location/user-groups': typeof LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutUserGroupsRoute
  '/$lang/orgs/$org/outbound/whs/$location/zones': typeof LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutZonesRoute
  '/$lang/orgs/$org/internal/whs/$location': typeof LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutIndexRoute
  '/$lang/orgs/$org/outbound/whs/$location': typeof LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutIndexRoute
  '/$lang/orgs/$org/internal/whs/$location/selector-sessions': typeof LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutSelectorSessionsIndexRoute
  '/$lang/orgs/$org/internal/whs/$location/task-plan-errors': typeof LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutTaskPlanErrorsIndexRoute
  '/$lang/orgs/$org/internal/whs/$location/task-plans': typeof LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutTaskPlansIndexRoute
  '/$lang/orgs/$org/outbound/whs/$location/audit-log': typeof LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutAuditLogIndexRoute
  '/$lang/orgs/$org/outbound/whs/$location/dashboard': typeof LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutDashboardIndexRoute
  '/$lang/orgs/$org/outbound/whs/$location/system-controls': typeof LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutSystemControlsIndexRoute
  '/$lang/orgs/$org/internal/whs/$location/webhooks/endpoints/new': typeof LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutWebhooksEndpointsNewRoute
  '/$lang/orgs/$org/internal/whs/$location/selector-tasks/$selectorId': typeof LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutSelectorTasksSelectorIdIndexRoute
  '/$lang/orgs/$org/internal/whs/$location/task-plans/$task-plan': typeof LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutTaskPlansTaskPlanIndexRoute
  '/$lang/orgs/$org/internal/whs/$location/task-plans/load-plans': typeof LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutTaskPlansLoadPlansIndexRoute
  '/$lang/orgs/$org/internal/whs/$location/webhooks/endpoints': typeof LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutWebhooksEndpointsIndexRoute
  '/$lang/orgs/$org/outbound/whs/$location/tasks': typeof LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutTasksLayoutIndexRoute
  '/$lang/orgs/$org/internal/whs/$location/webhooks/endpoints/$endpoint/deliveries': typeof LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutWebhooksEndpointsEndpointDeliveriesRoute
  '/$lang/orgs/$org/internal/whs/$location/task-plans/$task-plan/$task': typeof LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutTaskPlansTaskPlanTaskIndexRoute
  '/$lang/orgs/$org/internal/whs/$location/task-plans/$task-plan/simulate': typeof LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutTaskPlansTaskPlanSimulateIndexRoute
  '/$lang/orgs/$org/outbound/whs/$location/tasks/all': typeof LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutTasksLayoutAllIndexRoute
  '/$lang/orgs/$org/outbound/whs/$location/tasks/plans': typeof LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutTasksLayoutPlansIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/$lang/_layout': typeof LangLayoutRouteWithChildren
  '/$lang/': typeof LangIndexRoute
  '/$lang/_layout/auth/login': typeof LangLayoutAuthLoginRoute
  '/$lang/_layout/auth/redirect': typeof LangLayoutAuthRedirectRoute
  '/$lang/_layout/auth/reset-password': typeof LangLayoutAuthResetPasswordRoute
  '/$lang/_layout/orgs/$org/_layout': typeof LangLayoutOrgsOrgLayoutRouteWithChildren
  '/$lang/_layout/orgs/$org/_layout/deliver': typeof LangLayoutOrgsOrgLayoutDeliverRouteRouteWithChildren
  '/$lang/_layout/orgs/$org/_layout/internal': typeof LangLayoutOrgsOrgLayoutInternalRouteRouteWithChildren
  '/$lang/_layout/orgs/$org/_layout/outbound': typeof LangLayoutOrgsOrgLayoutOutboundRouteRouteWithChildren
  '/$lang/_layout/orgs/$org/_layout/analytics': typeof LangLayoutOrgsOrgLayoutAnalyticsRoute
  '/$lang/_layout/orgs/$org/_layout/': typeof LangLayoutOrgsOrgLayoutIndexRoute
  '/$lang/_layout/orgs/$org/_layout/deliver/': typeof LangLayoutOrgsOrgLayoutDeliverIndexRoute
  '/$lang/_layout/orgs/$org/_layout/internal/': typeof LangLayoutOrgsOrgLayoutInternalIndexRoute
  '/$lang/_layout/orgs/$org/_layout/outbound/': typeof LangLayoutOrgsOrgLayoutOutboundIndexRoute
  '/$lang/_layout/orgs/$org/_layout/deliver/manage/$tenant': typeof LangLayoutOrgsOrgLayoutDeliverManageTenantRouteWithChildren
  '/$lang/_layout/orgs/$org/_layout/deliver/manage/$tenant/drivers': typeof LangLayoutOrgsOrgLayoutDeliverManageTenantDriversRoute
  '/$lang/_layout/orgs/$org/_layout/deliver/manage/$tenant/questions': typeof LangLayoutOrgsOrgLayoutDeliverManageTenantQuestionsRoute
  '/$lang/_layout/orgs/$org/_layout/deliver/manage/$tenant/settings': typeof LangLayoutOrgsOrgLayoutDeliverManageTenantSettingsRoute
  '/$lang/_layout/orgs/$org/_layout/internal/whs/$location/_layout': typeof LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutRouteWithChildren
  '/$lang/_layout/orgs/$org/_layout/outbound/whs/$location/_layout': typeof LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutRouteWithChildren
  '/$lang/_layout/orgs/$org/_layout/deliver/manage/$tenant/': typeof LangLayoutOrgsOrgLayoutDeliverManageTenantIndexRoute
  '/$lang/_layout/orgs/$org/_layout/internal/whs/$location/_layout/ftp': typeof LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutFtpRoute
  '/$lang/_layout/orgs/$org/_layout/internal/whs/$location/_layout/ftp-config': typeof LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutFtpConfigRoute
  '/$lang/_layout/orgs/$org/_layout/internal/whs/$location/_layout/home': typeof LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutHomeRoute
  '/$lang/_layout/orgs/$org/_layout/outbound/whs/$location/_layout/customers': typeof LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutCustomersRoute
  '/$lang/_layout/orgs/$org/_layout/outbound/whs/$location/_layout/items': typeof LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutItemsRoute
  '/$lang/_layout/orgs/$org/_layout/outbound/whs/$location/_layout/locations': typeof LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutLocationsRoute
  '/$lang/_layout/orgs/$org/_layout/outbound/whs/$location/_layout/selectors': typeof LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutSelectorsRoute
  '/$lang/_layout/orgs/$org/_layout/outbound/whs/$location/_layout/user-groups': typeof LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutUserGroupsRoute
  '/$lang/_layout/orgs/$org/_layout/outbound/whs/$location/_layout/zones': typeof LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutZonesRoute
  '/$lang/_layout/orgs/$org/_layout/internal/whs/$location/_layout/': typeof LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutIndexRoute
  '/$lang/_layout/orgs/$org/_layout/outbound/whs/$location/_layout/': typeof LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutIndexRoute
  '/$lang/_layout/orgs/$org/_layout/outbound/whs/$location/_layout/tasks/_layout': typeof LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutTasksLayoutRouteWithChildren
  '/$lang/_layout/orgs/$org/_layout/internal/whs/$location/_layout/selector-sessions/': typeof LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutSelectorSessionsIndexRoute
  '/$lang/_layout/orgs/$org/_layout/internal/whs/$location/_layout/task-plan-errors/': typeof LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutTaskPlanErrorsIndexRoute
  '/$lang/_layout/orgs/$org/_layout/internal/whs/$location/_layout/task-plans/': typeof LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutTaskPlansIndexRoute
  '/$lang/_layout/orgs/$org/_layout/outbound/whs/$location/_layout/audit-log/': typeof LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutAuditLogIndexRoute
  '/$lang/_layout/orgs/$org/_layout/outbound/whs/$location/_layout/dashboard/': typeof LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutDashboardIndexRoute
  '/$lang/_layout/orgs/$org/_layout/outbound/whs/$location/_layout/system-controls/': typeof LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutSystemControlsIndexRoute
  '/$lang/_layout/orgs/$org/_layout/internal/whs/$location/_layout/webhooks/endpoints/new': typeof LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutWebhooksEndpointsNewRoute
  '/$lang/_layout/orgs/$org/_layout/internal/whs/$location/_layout/selector-tasks/$selectorId/': typeof LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutSelectorTasksSelectorIdIndexRoute
  '/$lang/_layout/orgs/$org/_layout/internal/whs/$location/_layout/task-plans/$task-plan/': typeof LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutTaskPlansTaskPlanIndexRoute
  '/$lang/_layout/orgs/$org/_layout/internal/whs/$location/_layout/task-plans/load-plans/': typeof LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutTaskPlansLoadPlansIndexRoute
  '/$lang/_layout/orgs/$org/_layout/internal/whs/$location/_layout/webhooks/endpoints/': typeof LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutWebhooksEndpointsIndexRoute
  '/$lang/_layout/orgs/$org/_layout/outbound/whs/$location/_layout/tasks/_layout/': typeof LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutTasksLayoutIndexRoute
  '/$lang/_layout/orgs/$org/_layout/internal/whs/$location/_layout/webhooks/endpoints/$endpoint/deliveries': typeof LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutWebhooksEndpointsEndpointDeliveriesRoute
  '/$lang/_layout/orgs/$org/_layout/internal/whs/$location/_layout/task-plans/$task-plan/$task/': typeof LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutTaskPlansTaskPlanTaskIndexRoute
  '/$lang/_layout/orgs/$org/_layout/internal/whs/$location/_layout/task-plans/$task-plan/simulate/': typeof LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutTaskPlansTaskPlanSimulateIndexRoute
  '/$lang/_layout/orgs/$org/_layout/outbound/whs/$location/_layout/tasks/_layout/all/': typeof LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutTasksLayoutAllIndexRoute
  '/$lang/_layout/orgs/$org/_layout/outbound/whs/$location/_layout/tasks/_layout/plans/': typeof LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutTasksLayoutPlansIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/$lang'
    | '/$lang/'
    | '/$lang/auth/login'
    | '/$lang/auth/redirect'
    | '/$lang/auth/reset-password'
    | '/$lang/orgs/$org'
    | '/$lang/orgs/$org/deliver'
    | '/$lang/orgs/$org/internal'
    | '/$lang/orgs/$org/outbound'
    | '/$lang/orgs/$org/analytics'
    | '/$lang/orgs/$org/'
    | '/$lang/orgs/$org/deliver/'
    | '/$lang/orgs/$org/internal/'
    | '/$lang/orgs/$org/outbound/'
    | '/$lang/orgs/$org/deliver/manage/$tenant'
    | '/$lang/orgs/$org/deliver/manage/$tenant/drivers'
    | '/$lang/orgs/$org/deliver/manage/$tenant/questions'
    | '/$lang/orgs/$org/deliver/manage/$tenant/settings'
    | '/$lang/orgs/$org/internal/whs/$location'
    | '/$lang/orgs/$org/outbound/whs/$location'
    | '/$lang/orgs/$org/deliver/manage/$tenant/'
    | '/$lang/orgs/$org/internal/whs/$location/ftp'
    | '/$lang/orgs/$org/internal/whs/$location/ftp-config'
    | '/$lang/orgs/$org/internal/whs/$location/home'
    | '/$lang/orgs/$org/outbound/whs/$location/customers'
    | '/$lang/orgs/$org/outbound/whs/$location/items'
    | '/$lang/orgs/$org/outbound/whs/$location/locations'
    | '/$lang/orgs/$org/outbound/whs/$location/selectors'
    | '/$lang/orgs/$org/outbound/whs/$location/user-groups'
    | '/$lang/orgs/$org/outbound/whs/$location/zones'
    | '/$lang/orgs/$org/internal/whs/$location/'
    | '/$lang/orgs/$org/outbound/whs/$location/'
    | '/$lang/orgs/$org/outbound/whs/$location/tasks'
    | '/$lang/orgs/$org/internal/whs/$location/selector-sessions/'
    | '/$lang/orgs/$org/internal/whs/$location/task-plan-errors/'
    | '/$lang/orgs/$org/internal/whs/$location/task-plans/'
    | '/$lang/orgs/$org/outbound/whs/$location/audit-log/'
    | '/$lang/orgs/$org/outbound/whs/$location/dashboard/'
    | '/$lang/orgs/$org/outbound/whs/$location/system-controls/'
    | '/$lang/orgs/$org/internal/whs/$location/webhooks/endpoints/new'
    | '/$lang/orgs/$org/internal/whs/$location/selector-tasks/$selectorId/'
    | '/$lang/orgs/$org/internal/whs/$location/task-plans/$task-plan/'
    | '/$lang/orgs/$org/internal/whs/$location/task-plans/load-plans/'
    | '/$lang/orgs/$org/internal/whs/$location/webhooks/endpoints/'
    | '/$lang/orgs/$org/outbound/whs/$location/tasks/'
    | '/$lang/orgs/$org/internal/whs/$location/webhooks/endpoints/$endpoint/deliveries'
    | '/$lang/orgs/$org/internal/whs/$location/task-plans/$task-plan/$task/'
    | '/$lang/orgs/$org/internal/whs/$location/task-plans/$task-plan/simulate/'
    | '/$lang/orgs/$org/outbound/whs/$location/tasks/all/'
    | '/$lang/orgs/$org/outbound/whs/$location/tasks/plans/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/$lang'
    | '/$lang/auth/login'
    | '/$lang/auth/redirect'
    | '/$lang/auth/reset-password'
    | '/$lang/orgs/$org/analytics'
    | '/$lang/orgs/$org'
    | '/$lang/orgs/$org/deliver'
    | '/$lang/orgs/$org/internal'
    | '/$lang/orgs/$org/outbound'
    | '/$lang/orgs/$org/deliver/manage/$tenant/drivers'
    | '/$lang/orgs/$org/deliver/manage/$tenant/questions'
    | '/$lang/orgs/$org/deliver/manage/$tenant/settings'
    | '/$lang/orgs/$org/deliver/manage/$tenant'
    | '/$lang/orgs/$org/internal/whs/$location/ftp'
    | '/$lang/orgs/$org/internal/whs/$location/ftp-config'
    | '/$lang/orgs/$org/internal/whs/$location/home'
    | '/$lang/orgs/$org/outbound/whs/$location/customers'
    | '/$lang/orgs/$org/outbound/whs/$location/items'
    | '/$lang/orgs/$org/outbound/whs/$location/locations'
    | '/$lang/orgs/$org/outbound/whs/$location/selectors'
    | '/$lang/orgs/$org/outbound/whs/$location/user-groups'
    | '/$lang/orgs/$org/outbound/whs/$location/zones'
    | '/$lang/orgs/$org/internal/whs/$location'
    | '/$lang/orgs/$org/outbound/whs/$location'
    | '/$lang/orgs/$org/internal/whs/$location/selector-sessions'
    | '/$lang/orgs/$org/internal/whs/$location/task-plan-errors'
    | '/$lang/orgs/$org/internal/whs/$location/task-plans'
    | '/$lang/orgs/$org/outbound/whs/$location/audit-log'
    | '/$lang/orgs/$org/outbound/whs/$location/dashboard'
    | '/$lang/orgs/$org/outbound/whs/$location/system-controls'
    | '/$lang/orgs/$org/internal/whs/$location/webhooks/endpoints/new'
    | '/$lang/orgs/$org/internal/whs/$location/selector-tasks/$selectorId'
    | '/$lang/orgs/$org/internal/whs/$location/task-plans/$task-plan'
    | '/$lang/orgs/$org/internal/whs/$location/task-plans/load-plans'
    | '/$lang/orgs/$org/internal/whs/$location/webhooks/endpoints'
    | '/$lang/orgs/$org/outbound/whs/$location/tasks'
    | '/$lang/orgs/$org/internal/whs/$location/webhooks/endpoints/$endpoint/deliveries'
    | '/$lang/orgs/$org/internal/whs/$location/task-plans/$task-plan/$task'
    | '/$lang/orgs/$org/internal/whs/$location/task-plans/$task-plan/simulate'
    | '/$lang/orgs/$org/outbound/whs/$location/tasks/all'
    | '/$lang/orgs/$org/outbound/whs/$location/tasks/plans'
  id:
    | '__root__'
    | '/'
    | '/$lang/_layout'
    | '/$lang/'
    | '/$lang/_layout/auth/login'
    | '/$lang/_layout/auth/redirect'
    | '/$lang/_layout/auth/reset-password'
    | '/$lang/_layout/orgs/$org/_layout'
    | '/$lang/_layout/orgs/$org/_layout/deliver'
    | '/$lang/_layout/orgs/$org/_layout/internal'
    | '/$lang/_layout/orgs/$org/_layout/outbound'
    | '/$lang/_layout/orgs/$org/_layout/analytics'
    | '/$lang/_layout/orgs/$org/_layout/'
    | '/$lang/_layout/orgs/$org/_layout/deliver/'
    | '/$lang/_layout/orgs/$org/_layout/internal/'
    | '/$lang/_layout/orgs/$org/_layout/outbound/'
    | '/$lang/_layout/orgs/$org/_layout/deliver/manage/$tenant'
    | '/$lang/_layout/orgs/$org/_layout/deliver/manage/$tenant/drivers'
    | '/$lang/_layout/orgs/$org/_layout/deliver/manage/$tenant/questions'
    | '/$lang/_layout/orgs/$org/_layout/deliver/manage/$tenant/settings'
    | '/$lang/_layout/orgs/$org/_layout/internal/whs/$location/_layout'
    | '/$lang/_layout/orgs/$org/_layout/outbound/whs/$location/_layout'
    | '/$lang/_layout/orgs/$org/_layout/deliver/manage/$tenant/'
    | '/$lang/_layout/orgs/$org/_layout/internal/whs/$location/_layout/ftp'
    | '/$lang/_layout/orgs/$org/_layout/internal/whs/$location/_layout/ftp-config'
    | '/$lang/_layout/orgs/$org/_layout/internal/whs/$location/_layout/home'
    | '/$lang/_layout/orgs/$org/_layout/outbound/whs/$location/_layout/customers'
    | '/$lang/_layout/orgs/$org/_layout/outbound/whs/$location/_layout/items'
    | '/$lang/_layout/orgs/$org/_layout/outbound/whs/$location/_layout/locations'
    | '/$lang/_layout/orgs/$org/_layout/outbound/whs/$location/_layout/selectors'
    | '/$lang/_layout/orgs/$org/_layout/outbound/whs/$location/_layout/user-groups'
    | '/$lang/_layout/orgs/$org/_layout/outbound/whs/$location/_layout/zones'
    | '/$lang/_layout/orgs/$org/_layout/internal/whs/$location/_layout/'
    | '/$lang/_layout/orgs/$org/_layout/outbound/whs/$location/_layout/'
    | '/$lang/_layout/orgs/$org/_layout/outbound/whs/$location/_layout/tasks/_layout'
    | '/$lang/_layout/orgs/$org/_layout/internal/whs/$location/_layout/selector-sessions/'
    | '/$lang/_layout/orgs/$org/_layout/internal/whs/$location/_layout/task-plan-errors/'
    | '/$lang/_layout/orgs/$org/_layout/internal/whs/$location/_layout/task-plans/'
    | '/$lang/_layout/orgs/$org/_layout/outbound/whs/$location/_layout/audit-log/'
    | '/$lang/_layout/orgs/$org/_layout/outbound/whs/$location/_layout/dashboard/'
    | '/$lang/_layout/orgs/$org/_layout/outbound/whs/$location/_layout/system-controls/'
    | '/$lang/_layout/orgs/$org/_layout/internal/whs/$location/_layout/webhooks/endpoints/new'
    | '/$lang/_layout/orgs/$org/_layout/internal/whs/$location/_layout/selector-tasks/$selectorId/'
    | '/$lang/_layout/orgs/$org/_layout/internal/whs/$location/_layout/task-plans/$task-plan/'
    | '/$lang/_layout/orgs/$org/_layout/internal/whs/$location/_layout/task-plans/load-plans/'
    | '/$lang/_layout/orgs/$org/_layout/internal/whs/$location/_layout/webhooks/endpoints/'
    | '/$lang/_layout/orgs/$org/_layout/outbound/whs/$location/_layout/tasks/_layout/'
    | '/$lang/_layout/orgs/$org/_layout/internal/whs/$location/_layout/webhooks/endpoints/$endpoint/deliveries'
    | '/$lang/_layout/orgs/$org/_layout/internal/whs/$location/_layout/task-plans/$task-plan/$task/'
    | '/$lang/_layout/orgs/$org/_layout/internal/whs/$location/_layout/task-plans/$task-plan/simulate/'
    | '/$lang/_layout/orgs/$org/_layout/outbound/whs/$location/_layout/tasks/_layout/all/'
    | '/$lang/_layout/orgs/$org/_layout/outbound/whs/$location/_layout/tasks/_layout/plans/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  LangLayoutRoute: typeof LangLayoutRouteWithChildren
  LangIndexRoute: typeof LangIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$lang/': {
      id: '/$lang/'
      path: '/$lang'
      fullPath: '/$lang/'
      preLoaderRoute: typeof LangIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$lang/_layout': {
      id: '/$lang/_layout'
      path: '/$lang'
      fullPath: '/$lang'
      preLoaderRoute: typeof LangLayoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$lang/_layout/auth/login': {
      id: '/$lang/_layout/auth/login'
      path: '/auth/login'
      fullPath: '/$lang/auth/login'
      preLoaderRoute: typeof LangLayoutAuthLoginRouteImport
      parentRoute: typeof LangLayoutRoute
    }
    '/$lang/_layout/auth/redirect': {
      id: '/$lang/_layout/auth/redirect'
      path: '/auth/redirect'
      fullPath: '/$lang/auth/redirect'
      preLoaderRoute: typeof LangLayoutAuthRedirectRouteImport
      parentRoute: typeof LangLayoutRoute
    }
    '/$lang/_layout/auth/reset-password': {
      id: '/$lang/_layout/auth/reset-password'
      path: '/auth/reset-password'
      fullPath: '/$lang/auth/reset-password'
      preLoaderRoute: typeof LangLayoutAuthResetPasswordRouteImport
      parentRoute: typeof LangLayoutRoute
    }
    '/$lang/_layout/orgs/$org/_layout': {
      id: '/$lang/_layout/orgs/$org/_layout'
      path: '/orgs/$org'
      fullPath: '/$lang/orgs/$org'
      preLoaderRoute: typeof LangLayoutOrgsOrgLayoutRouteImport
      parentRoute: typeof LangLayoutRoute
    }
    '/$lang/_layout/orgs/$org/_layout/': {
      id: '/$lang/_layout/orgs/$org/_layout/'
      path: '/'
      fullPath: '/$lang/orgs/$org/'
      preLoaderRoute: typeof LangLayoutOrgsOrgLayoutIndexRouteImport
      parentRoute: typeof LangLayoutOrgsOrgLayoutRoute
    }
    '/$lang/_layout/orgs/$org/_layout/analytics': {
      id: '/$lang/_layout/orgs/$org/_layout/analytics'
      path: '/analytics'
      fullPath: '/$lang/orgs/$org/analytics'
      preLoaderRoute: typeof LangLayoutOrgsOrgLayoutAnalyticsRouteImport
      parentRoute: typeof LangLayoutOrgsOrgLayoutRoute
    }
    '/$lang/_layout/orgs/$org/_layout/deliver': {
      id: '/$lang/_layout/orgs/$org/_layout/deliver'
      path: '/deliver'
      fullPath: '/$lang/orgs/$org/deliver'
      preLoaderRoute: typeof LangLayoutOrgsOrgLayoutDeliverRouteRouteImport
      parentRoute: typeof LangLayoutOrgsOrgLayoutRoute
    }
    '/$lang/_layout/orgs/$org/_layout/internal': {
      id: '/$lang/_layout/orgs/$org/_layout/internal'
      path: '/internal'
      fullPath: '/$lang/orgs/$org/internal'
      preLoaderRoute: typeof LangLayoutOrgsOrgLayoutInternalRouteRouteImport
      parentRoute: typeof LangLayoutOrgsOrgLayoutRoute
    }
    '/$lang/_layout/orgs/$org/_layout/outbound': {
      id: '/$lang/_layout/orgs/$org/_layout/outbound'
      path: '/outbound'
      fullPath: '/$lang/orgs/$org/outbound'
      preLoaderRoute: typeof LangLayoutOrgsOrgLayoutOutboundRouteRouteImport
      parentRoute: typeof LangLayoutOrgsOrgLayoutRoute
    }
    '/$lang/_layout/orgs/$org/_layout/deliver/': {
      id: '/$lang/_layout/orgs/$org/_layout/deliver/'
      path: '/'
      fullPath: '/$lang/orgs/$org/deliver/'
      preLoaderRoute: typeof LangLayoutOrgsOrgLayoutDeliverIndexRouteImport
      parentRoute: typeof LangLayoutOrgsOrgLayoutDeliverRouteRoute
    }
    '/$lang/_layout/orgs/$org/_layout/internal/': {
      id: '/$lang/_layout/orgs/$org/_layout/internal/'
      path: '/'
      fullPath: '/$lang/orgs/$org/internal/'
      preLoaderRoute: typeof LangLayoutOrgsOrgLayoutInternalIndexRouteImport
      parentRoute: typeof LangLayoutOrgsOrgLayoutInternalRouteRoute
    }
    '/$lang/_layout/orgs/$org/_layout/outbound/': {
      id: '/$lang/_layout/orgs/$org/_layout/outbound/'
      path: '/'
      fullPath: '/$lang/orgs/$org/outbound/'
      preLoaderRoute: typeof LangLayoutOrgsOrgLayoutOutboundIndexRouteImport
      parentRoute: typeof LangLayoutOrgsOrgLayoutOutboundRouteRoute
    }
    '/$lang/_layout/orgs/$org/_layout/deliver/manage/$tenant': {
      id: '/$lang/_layout/orgs/$org/_layout/deliver/manage/$tenant'
      path: '/manage/$tenant'
      fullPath: '/$lang/orgs/$org/deliver/manage/$tenant'
      preLoaderRoute: typeof LangLayoutOrgsOrgLayoutDeliverManageTenantRouteImport
      parentRoute: typeof LangLayoutOrgsOrgLayoutDeliverRouteRoute
    }
    '/$lang/_layout/orgs/$org/_layout/deliver/manage/$tenant/': {
      id: '/$lang/_layout/orgs/$org/_layout/deliver/manage/$tenant/'
      path: '/'
      fullPath: '/$lang/orgs/$org/deliver/manage/$tenant/'
      preLoaderRoute: typeof LangLayoutOrgsOrgLayoutDeliverManageTenantIndexRouteImport
      parentRoute: typeof LangLayoutOrgsOrgLayoutDeliverManageTenantRoute
    }
    '/$lang/_layout/orgs/$org/_layout/deliver/manage/$tenant/drivers': {
      id: '/$lang/_layout/orgs/$org/_layout/deliver/manage/$tenant/drivers'
      path: '/drivers'
      fullPath: '/$lang/orgs/$org/deliver/manage/$tenant/drivers'
      preLoaderRoute: typeof LangLayoutOrgsOrgLayoutDeliverManageTenantDriversRouteImport
      parentRoute: typeof LangLayoutOrgsOrgLayoutDeliverManageTenantRoute
    }
    '/$lang/_layout/orgs/$org/_layout/deliver/manage/$tenant/questions': {
      id: '/$lang/_layout/orgs/$org/_layout/deliver/manage/$tenant/questions'
      path: '/questions'
      fullPath: '/$lang/orgs/$org/deliver/manage/$tenant/questions'
      preLoaderRoute: typeof LangLayoutOrgsOrgLayoutDeliverManageTenantQuestionsRouteImport
      parentRoute: typeof LangLayoutOrgsOrgLayoutDeliverManageTenantRoute
    }
    '/$lang/_layout/orgs/$org/_layout/deliver/manage/$tenant/settings': {
      id: '/$lang/_layout/orgs/$org/_layout/deliver/manage/$tenant/settings'
      path: '/settings'
      fullPath: '/$lang/orgs/$org/deliver/manage/$tenant/settings'
      preLoaderRoute: typeof LangLayoutOrgsOrgLayoutDeliverManageTenantSettingsRouteImport
      parentRoute: typeof LangLayoutOrgsOrgLayoutDeliverManageTenantRoute
    }
    '/$lang/_layout/orgs/$org/_layout/internal/whs/$location/_layout': {
      id: '/$lang/_layout/orgs/$org/_layout/internal/whs/$location/_layout'
      path: '/whs/$location'
      fullPath: '/$lang/orgs/$org/internal/whs/$location'
      preLoaderRoute: typeof LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutRouteImport
      parentRoute: typeof LangLayoutOrgsOrgLayoutInternalRouteRoute
    }
    '/$lang/_layout/orgs/$org/_layout/outbound/whs/$location/_layout': {
      id: '/$lang/_layout/orgs/$org/_layout/outbound/whs/$location/_layout'
      path: '/whs/$location'
      fullPath: '/$lang/orgs/$org/outbound/whs/$location'
      preLoaderRoute: typeof LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutRouteImport
      parentRoute: typeof LangLayoutOrgsOrgLayoutOutboundRouteRoute
    }
    '/$lang/_layout/orgs/$org/_layout/internal/whs/$location/_layout/': {
      id: '/$lang/_layout/orgs/$org/_layout/internal/whs/$location/_layout/'
      path: '/'
      fullPath: '/$lang/orgs/$org/internal/whs/$location/'
      preLoaderRoute: typeof LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutIndexRouteImport
      parentRoute: typeof LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutRoute
    }
    '/$lang/_layout/orgs/$org/_layout/internal/whs/$location/_layout/ftp': {
      id: '/$lang/_layout/orgs/$org/_layout/internal/whs/$location/_layout/ftp'
      path: '/ftp'
      fullPath: '/$lang/orgs/$org/internal/whs/$location/ftp'
      preLoaderRoute: typeof LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutFtpRouteImport
      parentRoute: typeof LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutRoute
    }
    '/$lang/_layout/orgs/$org/_layout/internal/whs/$location/_layout/ftp-config': {
      id: '/$lang/_layout/orgs/$org/_layout/internal/whs/$location/_layout/ftp-config'
      path: '/ftp-config'
      fullPath: '/$lang/orgs/$org/internal/whs/$location/ftp-config'
      preLoaderRoute: typeof LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutFtpConfigRouteImport
      parentRoute: typeof LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutRoute
    }
    '/$lang/_layout/orgs/$org/_layout/internal/whs/$location/_layout/home': {
      id: '/$lang/_layout/orgs/$org/_layout/internal/whs/$location/_layout/home'
      path: '/home'
      fullPath: '/$lang/orgs/$org/internal/whs/$location/home'
      preLoaderRoute: typeof LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutHomeRouteImport
      parentRoute: typeof LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutRoute
    }
    '/$lang/_layout/orgs/$org/_layout/outbound/whs/$location/_layout/': {
      id: '/$lang/_layout/orgs/$org/_layout/outbound/whs/$location/_layout/'
      path: '/'
      fullPath: '/$lang/orgs/$org/outbound/whs/$location/'
      preLoaderRoute: typeof LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutIndexRouteImport
      parentRoute: typeof LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutRoute
    }
    '/$lang/_layout/orgs/$org/_layout/outbound/whs/$location/_layout/customers': {
      id: '/$lang/_layout/orgs/$org/_layout/outbound/whs/$location/_layout/customers'
      path: '/customers'
      fullPath: '/$lang/orgs/$org/outbound/whs/$location/customers'
      preLoaderRoute: typeof LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutCustomersRouteImport
      parentRoute: typeof LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutRoute
    }
    '/$lang/_layout/orgs/$org/_layout/outbound/whs/$location/_layout/items': {
      id: '/$lang/_layout/orgs/$org/_layout/outbound/whs/$location/_layout/items'
      path: '/items'
      fullPath: '/$lang/orgs/$org/outbound/whs/$location/items'
      preLoaderRoute: typeof LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutItemsRouteImport
      parentRoute: typeof LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutRoute
    }
    '/$lang/_layout/orgs/$org/_layout/outbound/whs/$location/_layout/locations': {
      id: '/$lang/_layout/orgs/$org/_layout/outbound/whs/$location/_layout/locations'
      path: '/locations'
      fullPath: '/$lang/orgs/$org/outbound/whs/$location/locations'
      preLoaderRoute: typeof LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutLocationsRouteImport
      parentRoute: typeof LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutRoute
    }
    '/$lang/_layout/orgs/$org/_layout/outbound/whs/$location/_layout/selectors': {
      id: '/$lang/_layout/orgs/$org/_layout/outbound/whs/$location/_layout/selectors'
      path: '/selectors'
      fullPath: '/$lang/orgs/$org/outbound/whs/$location/selectors'
      preLoaderRoute: typeof LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutSelectorsRouteImport
      parentRoute: typeof LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutRoute
    }
    '/$lang/_layout/orgs/$org/_layout/outbound/whs/$location/_layout/user-groups': {
      id: '/$lang/_layout/orgs/$org/_layout/outbound/whs/$location/_layout/user-groups'
      path: '/user-groups'
      fullPath: '/$lang/orgs/$org/outbound/whs/$location/user-groups'
      preLoaderRoute: typeof LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutUserGroupsRouteImport
      parentRoute: typeof LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutRoute
    }
    '/$lang/_layout/orgs/$org/_layout/outbound/whs/$location/_layout/zones': {
      id: '/$lang/_layout/orgs/$org/_layout/outbound/whs/$location/_layout/zones'
      path: '/zones'
      fullPath: '/$lang/orgs/$org/outbound/whs/$location/zones'
      preLoaderRoute: typeof LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutZonesRouteImport
      parentRoute: typeof LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutRoute
    }
    '/$lang/_layout/orgs/$org/_layout/internal/whs/$location/_layout/selector-sessions/': {
      id: '/$lang/_layout/orgs/$org/_layout/internal/whs/$location/_layout/selector-sessions/'
      path: '/selector-sessions'
      fullPath: '/$lang/orgs/$org/internal/whs/$location/selector-sessions/'
      preLoaderRoute: typeof LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutSelectorSessionsIndexRouteImport
      parentRoute: typeof LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutRoute
    }
    '/$lang/_layout/orgs/$org/_layout/internal/whs/$location/_layout/task-plan-errors/': {
      id: '/$lang/_layout/orgs/$org/_layout/internal/whs/$location/_layout/task-plan-errors/'
      path: '/task-plan-errors'
      fullPath: '/$lang/orgs/$org/internal/whs/$location/task-plan-errors/'
      preLoaderRoute: typeof LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutTaskPlanErrorsIndexRouteImport
      parentRoute: typeof LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutRoute
    }
    '/$lang/_layout/orgs/$org/_layout/internal/whs/$location/_layout/task-plans/': {
      id: '/$lang/_layout/orgs/$org/_layout/internal/whs/$location/_layout/task-plans/'
      path: '/task-plans'
      fullPath: '/$lang/orgs/$org/internal/whs/$location/task-plans/'
      preLoaderRoute: typeof LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutTaskPlansIndexRouteImport
      parentRoute: typeof LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutRoute
    }
    '/$lang/_layout/orgs/$org/_layout/outbound/whs/$location/_layout/audit-log/': {
      id: '/$lang/_layout/orgs/$org/_layout/outbound/whs/$location/_layout/audit-log/'
      path: '/audit-log'
      fullPath: '/$lang/orgs/$org/outbound/whs/$location/audit-log/'
      preLoaderRoute: typeof LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutAuditLogIndexRouteImport
      parentRoute: typeof LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutRoute
    }
    '/$lang/_layout/orgs/$org/_layout/outbound/whs/$location/_layout/dashboard/': {
      id: '/$lang/_layout/orgs/$org/_layout/outbound/whs/$location/_layout/dashboard/'
      path: '/dashboard'
      fullPath: '/$lang/orgs/$org/outbound/whs/$location/dashboard/'
      preLoaderRoute: typeof LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutDashboardIndexRouteImport
      parentRoute: typeof LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutRoute
    }
    '/$lang/_layout/orgs/$org/_layout/outbound/whs/$location/_layout/system-controls/': {
      id: '/$lang/_layout/orgs/$org/_layout/outbound/whs/$location/_layout/system-controls/'
      path: '/system-controls'
      fullPath: '/$lang/orgs/$org/outbound/whs/$location/system-controls/'
      preLoaderRoute: typeof LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutSystemControlsIndexRouteImport
      parentRoute: typeof LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutRoute
    }
    '/$lang/_layout/orgs/$org/_layout/outbound/whs/$location/_layout/tasks/_layout': {
      id: '/$lang/_layout/orgs/$org/_layout/outbound/whs/$location/_layout/tasks/_layout'
      path: '/tasks'
      fullPath: '/$lang/orgs/$org/outbound/whs/$location/tasks'
      preLoaderRoute: typeof LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutTasksLayoutRouteImport
      parentRoute: typeof LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutRoute
    }
    '/$lang/_layout/orgs/$org/_layout/internal/whs/$location/_layout/selector-tasks/$selectorId/': {
      id: '/$lang/_layout/orgs/$org/_layout/internal/whs/$location/_layout/selector-tasks/$selectorId/'
      path: '/selector-tasks/$selectorId'
      fullPath: '/$lang/orgs/$org/internal/whs/$location/selector-tasks/$selectorId/'
      preLoaderRoute: typeof LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutSelectorTasksSelectorIdIndexRouteImport
      parentRoute: typeof LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutRoute
    }
    '/$lang/_layout/orgs/$org/_layout/internal/whs/$location/_layout/task-plans/$task-plan/': {
      id: '/$lang/_layout/orgs/$org/_layout/internal/whs/$location/_layout/task-plans/$task-plan/'
      path: '/task-plans/$task-plan'
      fullPath: '/$lang/orgs/$org/internal/whs/$location/task-plans/$task-plan/'
      preLoaderRoute: typeof LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutTaskPlansTaskPlanIndexRouteImport
      parentRoute: typeof LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutRoute
    }
    '/$lang/_layout/orgs/$org/_layout/internal/whs/$location/_layout/task-plans/load-plans/': {
      id: '/$lang/_layout/orgs/$org/_layout/internal/whs/$location/_layout/task-plans/load-plans/'
      path: '/task-plans/load-plans'
      fullPath: '/$lang/orgs/$org/internal/whs/$location/task-plans/load-plans/'
      preLoaderRoute: typeof LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutTaskPlansLoadPlansIndexRouteImport
      parentRoute: typeof LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutRoute
    }
    '/$lang/_layout/orgs/$org/_layout/internal/whs/$location/_layout/webhooks/endpoints/': {
      id: '/$lang/_layout/orgs/$org/_layout/internal/whs/$location/_layout/webhooks/endpoints/'
      path: '/webhooks/endpoints'
      fullPath: '/$lang/orgs/$org/internal/whs/$location/webhooks/endpoints/'
      preLoaderRoute: typeof LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutWebhooksEndpointsIndexRouteImport
      parentRoute: typeof LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutRoute
    }
    '/$lang/_layout/orgs/$org/_layout/internal/whs/$location/_layout/webhooks/endpoints/new': {
      id: '/$lang/_layout/orgs/$org/_layout/internal/whs/$location/_layout/webhooks/endpoints/new'
      path: '/webhooks/endpoints/new'
      fullPath: '/$lang/orgs/$org/internal/whs/$location/webhooks/endpoints/new'
      preLoaderRoute: typeof LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutWebhooksEndpointsNewRouteImport
      parentRoute: typeof LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutRoute
    }
    '/$lang/_layout/orgs/$org/_layout/outbound/whs/$location/_layout/tasks/_layout/': {
      id: '/$lang/_layout/orgs/$org/_layout/outbound/whs/$location/_layout/tasks/_layout/'
      path: '/'
      fullPath: '/$lang/orgs/$org/outbound/whs/$location/tasks/'
      preLoaderRoute: typeof LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutTasksLayoutIndexRouteImport
      parentRoute: typeof LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutTasksLayoutRoute
    }
    '/$lang/_layout/orgs/$org/_layout/internal/whs/$location/_layout/task-plans/$task-plan/$task/': {
      id: '/$lang/_layout/orgs/$org/_layout/internal/whs/$location/_layout/task-plans/$task-plan/$task/'
      path: '/task-plans/$task-plan/$task'
      fullPath: '/$lang/orgs/$org/internal/whs/$location/task-plans/$task-plan/$task/'
      preLoaderRoute: typeof LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutTaskPlansTaskPlanTaskIndexRouteImport
      parentRoute: typeof LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutRoute
    }
    '/$lang/_layout/orgs/$org/_layout/internal/whs/$location/_layout/task-plans/$task-plan/simulate/': {
      id: '/$lang/_layout/orgs/$org/_layout/internal/whs/$location/_layout/task-plans/$task-plan/simulate/'
      path: '/task-plans/$task-plan/simulate'
      fullPath: '/$lang/orgs/$org/internal/whs/$location/task-plans/$task-plan/simulate/'
      preLoaderRoute: typeof LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutTaskPlansTaskPlanSimulateIndexRouteImport
      parentRoute: typeof LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutRoute
    }
    '/$lang/_layout/orgs/$org/_layout/internal/whs/$location/_layout/webhooks/endpoints/$endpoint/deliveries': {
      id: '/$lang/_layout/orgs/$org/_layout/internal/whs/$location/_layout/webhooks/endpoints/$endpoint/deliveries'
      path: '/webhooks/endpoints/$endpoint/deliveries'
      fullPath: '/$lang/orgs/$org/internal/whs/$location/webhooks/endpoints/$endpoint/deliveries'
      preLoaderRoute: typeof LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutWebhooksEndpointsEndpointDeliveriesRouteImport
      parentRoute: typeof LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutRoute
    }
    '/$lang/_layout/orgs/$org/_layout/outbound/whs/$location/_layout/tasks/_layout/all/': {
      id: '/$lang/_layout/orgs/$org/_layout/outbound/whs/$location/_layout/tasks/_layout/all/'
      path: '/all'
      fullPath: '/$lang/orgs/$org/outbound/whs/$location/tasks/all/'
      preLoaderRoute: typeof LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutTasksLayoutAllIndexRouteImport
      parentRoute: typeof LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutTasksLayoutRoute
    }
    '/$lang/_layout/orgs/$org/_layout/outbound/whs/$location/_layout/tasks/_layout/plans/': {
      id: '/$lang/_layout/orgs/$org/_layout/outbound/whs/$location/_layout/tasks/_layout/plans/'
      path: '/plans'
      fullPath: '/$lang/orgs/$org/outbound/whs/$location/tasks/plans/'
      preLoaderRoute: typeof LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutTasksLayoutPlansIndexRouteImport
      parentRoute: typeof LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutTasksLayoutRoute
    }
  }
}

interface LangLayoutOrgsOrgLayoutDeliverManageTenantRouteChildren {
  LangLayoutOrgsOrgLayoutDeliverManageTenantDriversRoute: typeof LangLayoutOrgsOrgLayoutDeliverManageTenantDriversRoute
  LangLayoutOrgsOrgLayoutDeliverManageTenantQuestionsRoute: typeof LangLayoutOrgsOrgLayoutDeliverManageTenantQuestionsRoute
  LangLayoutOrgsOrgLayoutDeliverManageTenantSettingsRoute: typeof LangLayoutOrgsOrgLayoutDeliverManageTenantSettingsRoute
  LangLayoutOrgsOrgLayoutDeliverManageTenantIndexRoute: typeof LangLayoutOrgsOrgLayoutDeliverManageTenantIndexRoute
}

const LangLayoutOrgsOrgLayoutDeliverManageTenantRouteChildren: LangLayoutOrgsOrgLayoutDeliverManageTenantRouteChildren =
  {
    LangLayoutOrgsOrgLayoutDeliverManageTenantDriversRoute:
      LangLayoutOrgsOrgLayoutDeliverManageTenantDriversRoute,
    LangLayoutOrgsOrgLayoutDeliverManageTenantQuestionsRoute:
      LangLayoutOrgsOrgLayoutDeliverManageTenantQuestionsRoute,
    LangLayoutOrgsOrgLayoutDeliverManageTenantSettingsRoute:
      LangLayoutOrgsOrgLayoutDeliverManageTenantSettingsRoute,
    LangLayoutOrgsOrgLayoutDeliverManageTenantIndexRoute:
      LangLayoutOrgsOrgLayoutDeliverManageTenantIndexRoute,
  }

const LangLayoutOrgsOrgLayoutDeliverManageTenantRouteWithChildren =
  LangLayoutOrgsOrgLayoutDeliverManageTenantRoute._addFileChildren(
    LangLayoutOrgsOrgLayoutDeliverManageTenantRouteChildren,
  )

interface LangLayoutOrgsOrgLayoutDeliverRouteRouteChildren {
  LangLayoutOrgsOrgLayoutDeliverIndexRoute: typeof LangLayoutOrgsOrgLayoutDeliverIndexRoute
  LangLayoutOrgsOrgLayoutDeliverManageTenantRoute: typeof LangLayoutOrgsOrgLayoutDeliverManageTenantRouteWithChildren
}

const LangLayoutOrgsOrgLayoutDeliverRouteRouteChildren: LangLayoutOrgsOrgLayoutDeliverRouteRouteChildren =
  {
    LangLayoutOrgsOrgLayoutDeliverIndexRoute:
      LangLayoutOrgsOrgLayoutDeliverIndexRoute,
    LangLayoutOrgsOrgLayoutDeliverManageTenantRoute:
      LangLayoutOrgsOrgLayoutDeliverManageTenantRouteWithChildren,
  }

const LangLayoutOrgsOrgLayoutDeliverRouteRouteWithChildren =
  LangLayoutOrgsOrgLayoutDeliverRouteRoute._addFileChildren(
    LangLayoutOrgsOrgLayoutDeliverRouteRouteChildren,
  )

interface LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutRouteChildren {
  LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutFtpRoute: typeof LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutFtpRoute
  LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutFtpConfigRoute: typeof LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutFtpConfigRoute
  LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutHomeRoute: typeof LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutHomeRoute
  LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutIndexRoute: typeof LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutIndexRoute
  LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutSelectorSessionsIndexRoute: typeof LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutSelectorSessionsIndexRoute
  LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutTaskPlanErrorsIndexRoute: typeof LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutTaskPlanErrorsIndexRoute
  LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutTaskPlansIndexRoute: typeof LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutTaskPlansIndexRoute
  LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutWebhooksEndpointsNewRoute: typeof LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutWebhooksEndpointsNewRoute
  LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutSelectorTasksSelectorIdIndexRoute: typeof LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutSelectorTasksSelectorIdIndexRoute
  LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutTaskPlansTaskPlanIndexRoute: typeof LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutTaskPlansTaskPlanIndexRoute
  LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutTaskPlansLoadPlansIndexRoute: typeof LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutTaskPlansLoadPlansIndexRoute
  LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutWebhooksEndpointsIndexRoute: typeof LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutWebhooksEndpointsIndexRoute
  LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutWebhooksEndpointsEndpointDeliveriesRoute: typeof LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutWebhooksEndpointsEndpointDeliveriesRoute
  LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutTaskPlansTaskPlanTaskIndexRoute: typeof LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutTaskPlansTaskPlanTaskIndexRoute
  LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutTaskPlansTaskPlanSimulateIndexRoute: typeof LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutTaskPlansTaskPlanSimulateIndexRoute
}

const LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutRouteChildren: LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutRouteChildren =
  {
    LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutFtpRoute:
      LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutFtpRoute,
    LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutFtpConfigRoute:
      LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutFtpConfigRoute,
    LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutHomeRoute:
      LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutHomeRoute,
    LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutIndexRoute:
      LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutIndexRoute,
    LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutSelectorSessionsIndexRoute:
      LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutSelectorSessionsIndexRoute,
    LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutTaskPlanErrorsIndexRoute:
      LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutTaskPlanErrorsIndexRoute,
    LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutTaskPlansIndexRoute:
      LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutTaskPlansIndexRoute,
    LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutWebhooksEndpointsNewRoute:
      LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutWebhooksEndpointsNewRoute,
    LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutSelectorTasksSelectorIdIndexRoute:
      LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutSelectorTasksSelectorIdIndexRoute,
    LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutTaskPlansTaskPlanIndexRoute:
      LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutTaskPlansTaskPlanIndexRoute,
    LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutTaskPlansLoadPlansIndexRoute:
      LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutTaskPlansLoadPlansIndexRoute,
    LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutWebhooksEndpointsIndexRoute:
      LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutWebhooksEndpointsIndexRoute,
    LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutWebhooksEndpointsEndpointDeliveriesRoute:
      LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutWebhooksEndpointsEndpointDeliveriesRoute,
    LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutTaskPlansTaskPlanTaskIndexRoute:
      LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutTaskPlansTaskPlanTaskIndexRoute,
    LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutTaskPlansTaskPlanSimulateIndexRoute:
      LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutTaskPlansTaskPlanSimulateIndexRoute,
  }

const LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutRouteWithChildren =
  LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutRoute._addFileChildren(
    LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutRouteChildren,
  )

interface LangLayoutOrgsOrgLayoutInternalRouteRouteChildren {
  LangLayoutOrgsOrgLayoutInternalIndexRoute: typeof LangLayoutOrgsOrgLayoutInternalIndexRoute
  LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutRoute: typeof LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutRouteWithChildren
}

const LangLayoutOrgsOrgLayoutInternalRouteRouteChildren: LangLayoutOrgsOrgLayoutInternalRouteRouteChildren =
  {
    LangLayoutOrgsOrgLayoutInternalIndexRoute:
      LangLayoutOrgsOrgLayoutInternalIndexRoute,
    LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutRoute:
      LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutRouteWithChildren,
  }

const LangLayoutOrgsOrgLayoutInternalRouteRouteWithChildren =
  LangLayoutOrgsOrgLayoutInternalRouteRoute._addFileChildren(
    LangLayoutOrgsOrgLayoutInternalRouteRouteChildren,
  )

interface LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutTasksLayoutRouteChildren {
  LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutTasksLayoutIndexRoute: typeof LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutTasksLayoutIndexRoute
  LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutTasksLayoutAllIndexRoute: typeof LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutTasksLayoutAllIndexRoute
  LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutTasksLayoutPlansIndexRoute: typeof LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutTasksLayoutPlansIndexRoute
}

const LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutTasksLayoutRouteChildren: LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutTasksLayoutRouteChildren =
  {
    LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutTasksLayoutIndexRoute:
      LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutTasksLayoutIndexRoute,
    LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutTasksLayoutAllIndexRoute:
      LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutTasksLayoutAllIndexRoute,
    LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutTasksLayoutPlansIndexRoute:
      LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutTasksLayoutPlansIndexRoute,
  }

const LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutTasksLayoutRouteWithChildren =
  LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutTasksLayoutRoute._addFileChildren(
    LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutTasksLayoutRouteChildren,
  )

interface LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutRouteChildren {
  LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutCustomersRoute: typeof LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutCustomersRoute
  LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutItemsRoute: typeof LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutItemsRoute
  LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutLocationsRoute: typeof LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutLocationsRoute
  LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutSelectorsRoute: typeof LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutSelectorsRoute
  LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutUserGroupsRoute: typeof LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutUserGroupsRoute
  LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutZonesRoute: typeof LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutZonesRoute
  LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutIndexRoute: typeof LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutIndexRoute
  LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutTasksLayoutRoute: typeof LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutTasksLayoutRouteWithChildren
  LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutAuditLogIndexRoute: typeof LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutAuditLogIndexRoute
  LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutDashboardIndexRoute: typeof LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutDashboardIndexRoute
  LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutSystemControlsIndexRoute: typeof LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutSystemControlsIndexRoute
}

const LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutRouteChildren: LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutRouteChildren =
  {
    LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutCustomersRoute:
      LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutCustomersRoute,
    LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutItemsRoute:
      LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutItemsRoute,
    LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutLocationsRoute:
      LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutLocationsRoute,
    LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutSelectorsRoute:
      LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutSelectorsRoute,
    LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutUserGroupsRoute:
      LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutUserGroupsRoute,
    LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutZonesRoute:
      LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutZonesRoute,
    LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutIndexRoute:
      LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutIndexRoute,
    LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutTasksLayoutRoute:
      LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutTasksLayoutRouteWithChildren,
    LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutAuditLogIndexRoute:
      LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutAuditLogIndexRoute,
    LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutDashboardIndexRoute:
      LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutDashboardIndexRoute,
    LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutSystemControlsIndexRoute:
      LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutSystemControlsIndexRoute,
  }

const LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutRouteWithChildren =
  LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutRoute._addFileChildren(
    LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutRouteChildren,
  )

interface LangLayoutOrgsOrgLayoutOutboundRouteRouteChildren {
  LangLayoutOrgsOrgLayoutOutboundIndexRoute: typeof LangLayoutOrgsOrgLayoutOutboundIndexRoute
  LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutRoute: typeof LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutRouteWithChildren
}

const LangLayoutOrgsOrgLayoutOutboundRouteRouteChildren: LangLayoutOrgsOrgLayoutOutboundRouteRouteChildren =
  {
    LangLayoutOrgsOrgLayoutOutboundIndexRoute:
      LangLayoutOrgsOrgLayoutOutboundIndexRoute,
    LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutRoute:
      LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutRouteWithChildren,
  }

const LangLayoutOrgsOrgLayoutOutboundRouteRouteWithChildren =
  LangLayoutOrgsOrgLayoutOutboundRouteRoute._addFileChildren(
    LangLayoutOrgsOrgLayoutOutboundRouteRouteChildren,
  )

interface LangLayoutOrgsOrgLayoutRouteChildren {
  LangLayoutOrgsOrgLayoutDeliverRouteRoute: typeof LangLayoutOrgsOrgLayoutDeliverRouteRouteWithChildren
  LangLayoutOrgsOrgLayoutInternalRouteRoute: typeof LangLayoutOrgsOrgLayoutInternalRouteRouteWithChildren
  LangLayoutOrgsOrgLayoutOutboundRouteRoute: typeof LangLayoutOrgsOrgLayoutOutboundRouteRouteWithChildren
  LangLayoutOrgsOrgLayoutAnalyticsRoute: typeof LangLayoutOrgsOrgLayoutAnalyticsRoute
  LangLayoutOrgsOrgLayoutIndexRoute: typeof LangLayoutOrgsOrgLayoutIndexRoute
}

const LangLayoutOrgsOrgLayoutRouteChildren: LangLayoutOrgsOrgLayoutRouteChildren =
  {
    LangLayoutOrgsOrgLayoutDeliverRouteRoute:
      LangLayoutOrgsOrgLayoutDeliverRouteRouteWithChildren,
    LangLayoutOrgsOrgLayoutInternalRouteRoute:
      LangLayoutOrgsOrgLayoutInternalRouteRouteWithChildren,
    LangLayoutOrgsOrgLayoutOutboundRouteRoute:
      LangLayoutOrgsOrgLayoutOutboundRouteRouteWithChildren,
    LangLayoutOrgsOrgLayoutAnalyticsRoute:
      LangLayoutOrgsOrgLayoutAnalyticsRoute,
    LangLayoutOrgsOrgLayoutIndexRoute: LangLayoutOrgsOrgLayoutIndexRoute,
  }

const LangLayoutOrgsOrgLayoutRouteWithChildren =
  LangLayoutOrgsOrgLayoutRoute._addFileChildren(
    LangLayoutOrgsOrgLayoutRouteChildren,
  )

interface LangLayoutRouteChildren {
  LangLayoutAuthLoginRoute: typeof LangLayoutAuthLoginRoute
  LangLayoutAuthRedirectRoute: typeof LangLayoutAuthRedirectRoute
  LangLayoutAuthResetPasswordRoute: typeof LangLayoutAuthResetPasswordRoute
  LangLayoutOrgsOrgLayoutRoute: typeof LangLayoutOrgsOrgLayoutRouteWithChildren
}

const LangLayoutRouteChildren: LangLayoutRouteChildren = {
  LangLayoutAuthLoginRoute: LangLayoutAuthLoginRoute,
  LangLayoutAuthRedirectRoute: LangLayoutAuthRedirectRoute,
  LangLayoutAuthResetPasswordRoute: LangLayoutAuthResetPasswordRoute,
  LangLayoutOrgsOrgLayoutRoute: LangLayoutOrgsOrgLayoutRouteWithChildren,
}

const LangLayoutRouteWithChildren = LangLayoutRoute._addFileChildren(
  LangLayoutRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  LangLayoutRoute: LangLayoutRouteWithChildren,
  LangIndexRoute: LangIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
